import React from 'react';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from "../../../../../../../../../../../../components/button";
import {addToOtherLabel, contactContent} from '../../../../../../../../../../../../../actions/contactDetailsActions';
import {getSharingDetailsPopup} from "../../../../../../../../../../../../../actions/sharingDetailsActions";

function ContactInfoShareBtn (props) {

    const { t } = useTranslation();
    const {
	    setContactContent,
	    setAddToOtherLabel,
        findContactDetails,
        sharingDetailsPopup,
        getSharingDetailsPopup,
        selectedContactsGroup
    } = props;

    const handleClick = () => {
        if(sharingDetailsPopup.length > 0){
            setContactContent("sharing-settings");
            setAddToOtherLabel(true);
        } else {
            getSharingDetailsPopup([true, 'select_one_label', [{
                'id': findContactDetails.id,
                'type': findContactDetails.phoneContactEntry.type
            }], findContactDetails.name]);
        }
    };

    return (
        <Button className="btn-link p-0 pr-2" onClick={handleClick} title = {t("tutorialShareIndividualContact")} disabled={selectedContactsGroup === null || findContactDetails.shareable === false || (selectedContactsGroup && selectedContactsGroup.directorySyncStatus === 'RUNNING')}>
            <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 16.09C15.6767 16.09 14.94 16.4275 14.3767 16.9563L6.6525 12.2875C6.70667 12.0287 6.75 11.77 6.75 11.5C6.75 11.23 6.70667 10.9713 6.6525 10.7125L14.29 6.08875C14.875 6.65125 15.6442 7 16.5 7C18.2983 7 19.75 5.4925 19.75 3.625C19.75 1.7575 18.2983 0.25 16.5 0.25C14.7017 0.25 13.25 1.7575 13.25 3.625C13.25 3.895 13.2933 4.15375 13.3475 4.4125L5.71 9.03625C5.125 8.47375 4.35583 8.125 3.5 8.125C1.70167 8.125 0.25 9.6325 0.25 11.5C0.25 13.3675 1.70167 14.875 3.5 14.875C4.35583 14.875 5.125 14.5262 5.71 13.9637L13.4233 18.6438C13.3692 18.88 13.3367 19.1275 13.3367 19.375C13.3367 21.1863 14.7558 22.66 16.5 22.66C18.2442 22.66 19.6633 21.1863 19.6633 19.375C19.6633 17.5637 18.2442 16.09 16.5 16.09Z" fill="#314D60"/>
            </svg>
        </Button>
    )
}

const mapStateToProps = (state) => {
    return {
	    selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
	    collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
	    setContactContent : (string) => {
		    dispatch(contactContent(string))
	    },
	    setAddToOtherLabel: (boolean) => {
	        dispatch(addToOtherLabel(boolean))
	    },
        getSharingDetailsPopup: (array) => {
            dispatch(getSharingDetailsPopup(array))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfoShareBtn);
